import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { PATH_USERS } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useUsersContext } from "../context";

export const useUserBreadcrumbs = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const context = useUsersContext();

  const breadcrumbItems = useMemo((): BreadcrumbItem[] => {
    const isCreateMode = location.pathname.endsWith("/new");
    const items: BreadcrumbItem[] = [
      {
        label: t("navigation.users"),
        href: PATH_USERS,
      },
    ];

    if (isCreateMode) {
      items.push({
        label: t("users.createForm.title"),
        href: undefined,
      });
    } else if (context.data) {
      items.push({
        label: context.data.full_name,
        href: `${PATH_USERS}/${context.data.id}`,
      });
    }
    return items;
  }, [location.pathname, t, context.data]);

  return {
    breadcrumbItems,
  };
};
